import React, { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext();

export function CartProvider({ children }) {
  const [cart, setCart] = useState(() => {
    // Initialize cart from localStorage
    const savedCart = localStorage.getItem('cart');
    return savedCart ? JSON.parse(savedCart) : [];
  });

  useEffect(() => {
    // Save cart to localStorage whenever it changes
    localStorage.setItem('cart', JSON.stringify(cart));
  }, [cart]);

  const addToCart = (item) => {
    setCart((prev) => {
      const existingItem = prev.find(
        (i) =>
          i.id === item.id &&
          i.selectedSize === item.selectedSize &&
          i.selectedColor === item.selectedColor &&
          i.format === item.format
      );
      if (existingItem) {
        return prev.map((i) =>
          i.id === item.id &&
          i.selectedSize === item.selectedSize &&
          i.selectedColor === item.selectedColor &&
          i.format === item.format
            ? { ...i, quantity: i.quantity + item.quantity }
            : i
        );
      }
      return [...prev, { ...item, variantKey: `${item.id}-${item.selectedSize || ''}-${item.selectedColor || ''}-${item.format || ''}` }];
    });
  };

  const removeFromCart = (variantKey) => {
    setCart((prev) => prev.filter((item) => item.variantKey !== variantKey));
  };

  const updateQuantity = (variantKey, quantity) => {
    if (quantity <= 0) {
      removeFromCart(variantKey);
    } else {
      setCart((prev) =>
        prev.map((item) =>
          item.variantKey === variantKey ? { ...item, quantity } : item
        )
      );
    }
  };

  const clearCart = () => {
    setCart([]);
    localStorage.removeItem('cart');
  };

  const getTotal = () => {
    return cart.reduce((total, item) => total + item.price * item.quantity, 0);
  };

  const restoreLastOrder = () => {
    const lastOrder = localStorage.getItem('lastOrder');
    return lastOrder ? JSON.parse(lastOrder) : null;
  };

  return (
    <CartContext.Provider
      value={{
        cart,
        addToCart,
        removeFromCart,
        updateQuantity,
        clearCart,
        getTotal,
        restoreLastOrder,
      }}
    >
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);